/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import FloatingInput from "../../../../components/input/FloatingInput";
import FloatingNumber from "../../../../components/input/FloatingNumber";
import ControlledField from "./ControlledField";

export default function PropertyDetailsSection({
  ttbData,
  formatCurrency,
  isCorrectProperty,
  setIsCorrectProperty,
  isInitialLoad,
  // setIsInitialLoad,
  useAnnualPropertyTax,
  setUseAnnualPropertyTax,
  useMortgageBalance,
  setUseMortgageBalance,
  salesPriceError,
  mortgageAmountError,
  useHomeWarranty,
  setUseHomeWarranty,
  getValues,
  setValue,
  handleCurrencyBlur,
  // onSalesPriceBlur,
  handleCalculate,
  control,
  cleanNumber,
  watch,
}) {
  const gv = (path, fallback = "") => {
    try {
      if (typeof getValues === "function") return getValues(path) ?? fallback;
    } catch (e) {
      // ignore
    }
    return fallback;
  };

  const RadioGroup = ({ name, value, onChange, options }) => (
    <div className="frm-radio">
      {options.map((opt) => (
        <label key={opt.value}>
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
          />{" "}
          {opt.label}
        </label>
      ))}
    </div>
  );

  const upsertCompensation = (keyName, rootField, labelText, v) => {
    try {
      const prev =
        (typeof getValues === "function"
          ? getValues("compensationMeta")
          : []) || [];
      const arr = Array.isArray(prev) ? prev.slice() : [];
      const idx = arr.findIndex(
        (it) => (it?.key || "").toString().toLowerCase() === keyName
      );
      if (idx >= 0) arr[idx] = { ...arr[idx], rate: v };
      else arr.push({ key: keyName, rate: v, label: labelText });
      setValue && setValue("compensationMeta", arr);
      setValue && setValue(rootField, v);
    } catch (err) {
      console.warn("Failed updating compensation", err);
    }
  };

  useEffect(() => {
    if (!watch) return;
    let unsub;
    try {
      // watch supports a subscription callback which returns an unsubscribe function
      unsub = watch((value, { name, type } = {}) => {
        try {
          //console.log("[ManualSheetSection] form change ->", { name, type, value });
        } catch (e) {
          // swallow any console errors in environments where console might be unavailable
        }
      });
    } catch (err) {
      // older RHF versions or unexpected shapes: fallback to no-op
    }
    return () => {
      try {
        if (typeof unsub === "function") unsub();
        else if (unsub && typeof unsub.unsubscribe === "function")
          unsub.unsubscribe();
      } catch (e) {
        // ignore
      }
    };
  }, [watch]);

  return (
    <div className="property-detail-container">
      {isInitialLoad && (
        <>
          <div className="property-details-list">
            <div className="property-question">
              <div className="content-description">
                <p className="heading-d txtclr">
                  Is this the correct property?&nbsp;&nbsp;
                </p>
              </div>
              <div className="form-value">
                <div className="frm-radio">
                  <label>
                    <input
                      type="radio"
                      name="correctproperty"
                      value="yes"
                      checked={isCorrectProperty === true}
                      onChange={() => setIsCorrectProperty(true)}
                    />{" "}
                    Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="correctproperty"
                      value="no"
                      checked={isCorrectProperty === false}
                      onChange={() => setIsCorrectProperty(false)}
                    />{" "}
                    No
                  </label>
                </div>
              </div>
            </div>

            {isCorrectProperty && (
              <>
                {Number(ttbData?.taxAmount) > 0 && (
                  <>
                    <div className="property-question p-t-20 m-t-20 border-top-sec">
                      <div className="content-description">
                        <p className="heading-f txtclr">
                          We see the annual Property Tax on this property is{" "}
                          <button>${formatCurrency(ttbData.taxAmount)}</button>{" "}
                          which was the bill in {ttbData.taxYear}.
                        </p>
                      </div>
                    </div>

                    <div className="property-question m-t-20">
                      <div className="content-description">
                        <p className="heading-b txtclr">
                          Do you want to use this amount in the calculations?
                        </p>
                      </div>
                      <div className="form-value">
                        <RadioGroup
                          name="annualPropertyTaxUse"
                          value={useAnnualPropertyTax}
                          onChange={(val) =>
                            setUseAnnualPropertyTax(val === true)
                          }
                          options={[
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                          ]}
                        />
                        {/* <div className="frm-radio">
                          <label>
                            <input type="radio" name="annualPropertyTaxUse" value="yes" checked={useAnnualPropertyTax === true} onChange={() => setUseAnnualPropertyTax(true)} />{' '}
                            Yes
                          </label>
                          <label>
                            <input type="radio" name="annualPropertyTaxUse" value="no" checked={useAnnualPropertyTax === false} onChange={() => setUseAnnualPropertyTax(false)} />{' '}
                            No
                          </label>
                        </div> */}
                      </div>
                    </div>
                  </>
                )}

                {Number(ttbData?.loanBalance?.balance) > 0 && (
                  <>
                    <div className="property-question p-t-20 m-t-20 border-top-sec">
                      <div className="content-description">
                        <p className="heading-f txtclr">
                          We see a potential mortgage balance of{" "}
                          <button>
                            ${formatCurrency(ttbData.loanBalance?.balance)}
                          </button>{" "}
                          based upon our calculations.
                        </p>
                      </div>
                    </div>

                    <div className="property-question m-t-20">
                      <div className="content-description">
                        <p className="heading-b txtclr">
                          Do you want to use this amount in the calculations?
                        </p>
                      </div>
                      <div className="form-value">
                        <div className="frm-radio">
                          <label>
                            <input
                              type="radio"
                              name="mortgagebalance"
                              value="yes"
                              checked={useMortgageBalance === true}
                              onChange={() => {
                                try {
                                  setUseMortgageBalance(true);
                                  // Ensure RHF autoEstimateLoan is set and update loansToBePaid entries
                                  setValue &&
                                    setValue(
                                      "loanInfoMeta.autoEstimateLoan",
                                      true
                                    );
                                  const bal =
                                    ttbData?.loanBalance?.balance ?? "";
                                  const rate =
                                    ttbData?.loanBalance?.interestRate ?? "";
                                  // write into RHF so LoansToBePaid rows stay in sync
                                  setValue &&
                                    setValue(
                                      "loanInfoMeta.loansToBePaidBalance1",
                                      bal
                                    );
                                  setValue &&
                                    setValue(
                                      "loanInfoMeta.loansToBePaidRate1",
                                      rate
                                    );
                                } catch (e) {
                                  console.warn(
                                    "Failed syncing mortgage balance -> RHF",
                                    e
                                  );
                                }
                              }}
                            />{" "}
                            Yes
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="mortgagebalance"
                              value="no"
                              checked={useMortgageBalance === false}
                              onChange={() => {
                                try {
                                  setUseMortgageBalance(false);
                                  // disable auto estimate in RHF and copy mortgageAmount into loansToBePaidBalance1
                                  setValue &&
                                    setValue(
                                      "loanInfoMeta.autoEstimateLoan",
                                      false
                                    );
                                  // prefer RHF mortgageAmount value if present
                                  const mort =
                                    (typeof getValues === "function"
                                      ? getValues("loanInfoMeta.mortgageAmount")
                                      : "") || "";
                                  setValue &&
                                    setValue(
                                      "loanInfoMeta.loansToBePaidBalance1",
                                      mort
                                    );
                                } catch (e) {
                                  console.warn(
                                    "Failed syncing mortgageAmount -> loansToBePaid",
                                    e
                                  );
                                }
                              }}
                            />{" "}
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    {!useMortgageBalance && (
                      <div className="property-question m-t-20">
                        <div className="content-description">
                          <p className="heading-b txtclr">
                            What amount do you want to use in the calculations?
                          </p>
                        </div>
                        <div className="form-value">
                          <div className="form-group sign-of-amount">
                            <ControlledField
                              name="loanInfoMeta.mortgageAmount"
                              control={control}
                              defaultValue={gv(
                                "loanInfoMeta.mortgageAmount",
                                "0.00"
                              )}
                              InputComponent={FloatingNumber}
                              placeholder=""
                              type="text"
                              cleanNumber={cleanNumber}
                              handleCurrencyBlur={handleCurrencyBlur}
                              onFormatted={(name, formatted) => {
                                // when user enters mortgageAmount and they're NOT using the auto-estimate path,
                                // write the mortgageAmount into loansToBePaidBalance1 so downstream logic reads a single source
                                try {
                                  if (!useMortgageBalance) {
                                    setValue &&
                                      setValue(
                                        "loanInfoMeta.loansToBePaidBalance1",
                                        formatted
                                      );
                                    // also ensure autoEstimateLoan flag in RHF is false
                                    setValue &&
                                      setValue(
                                        "loanInfoMeta.autoEstimateLoan",
                                        false
                                      );
                                  }
                                } catch (err) {
                                  console.warn(
                                    "Failed to sync mortgageAmount to loansToBePaidBalance1",
                                    err
                                  );
                                }
                              }}
                            />
                            {mortgageAmountError && (
                              <div className="text-red-600 text-sm mt-1">
                                {mortgageAmountError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                <div className="property-question p-t-20 m-t-20 border-top-sec">
                  <div className="content-description">
                    <p className="heading-f txtclr">Seller Must Net details </p>
                  </div>
                </div>

                <div className="property-question m-t-20">
                  <div className="content-description">
                    <p className="heading-b txtclr">
                      What is the Seller Must Net? 
                    </p>
                  </div>
                  <div className="form-value">
                    <div className="form-group sign-of-amount">
                      <ControlledField
                        name="sellerMustNet"
                        control={control}
                        defaultValue={gv("sellerMustNet", "0.00")}
                        InputComponent={FloatingNumber}
                        placeholder=""
                        type="text"
                        cleanNumber={cleanNumber}
                        handleCurrencyBlur={handleCurrencyBlur}
                        onFormatted={(name, formatted) => {
                          // ControlledField will call onFormatted after formatting the value.
                          // Ensure we call the parent handler with the formatted value.
                          /* try {
                            onSalesPriceBlur && onSalesPriceBlur(formatted);
                          } catch (err) {
                            // ignore
                          } */
                        }}
                      />

                      {salesPriceError && (
                        <div className="text-red-600 text-sm mt-1">
                          {salesPriceError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="property-question p-t-20 m-t-20 border-top-sec">
                  <div className="content-description">
                    <p className="heading-f txtclr">Agent Commission Split </p>
                  </div>
                </div>

                <div className="property-question m-t-20">
                  <div className="lable-wrap">
                    <div className="frm-field-c">
                      {(() => {
                        const arr =
                          (getValues
                            ? getValues("compensationMeta") || []
                            : []) || [];
                        const sellerItem = arr.find(
                          (it) =>
                            (it?.key || "").toString().toLowerCase() ===
                            "seller_broker_comp_pct"
                        );
                        
                        const sellerLabelText =
                          sellerItem?.label || "Seller2Net Broker Compensation";
                        const sellerValue = parseFloat(sellerItem?.value?.toString().replace(/,/g, "") || 0) || 0;
                        const sellerRate = parseFloat(sellerItem?.rate?.toString().replace(/,/g, "") || 0) || 0;
                        const sellerRateVal =
                        sellerValue > 0 ? sellerValue : sellerRate ??
                          (getValues ? getValues("listingAgentSplit") : "") ??
                          "";
                        
                        return (
                          <>
                            <label className="heading-d">
                              {sellerLabelText}:
                            </label>
                            <div className={ sellerValue > 0 ? "form-group sign-of-amount" : "form-group sign-of-percentage"}>
                              <FloatingNumber
                                type="text"
                                name="listingAgent"
                                label=""
                                placeholder="0.00"
                                className="inpt-pla"
                                value={sellerRateVal}
                                onChange={(e) =>
                                  upsertCompensation(
                                    "seller_broker_comp_pct",
                                    "listingAgentSplit",
                                    sellerLabelText,
                                    e?.target?.value ?? ""
                                  )
                                }
                              />
                            </div>
                          </>
                        );
                      })()}
                    </div>

                    <div className="frm-field-c">
                      {(() => {
                        const arr =
                          (getValues
                            ? getValues("compensationMeta") || []
                            : []) || [];
                        const buyerItem = arr.find(
                          (it) =>
                            (it?.key || "").toString().toLowerCase() ===
                            "buyer_broker_comp_pct"
                        );
                        const buyerLabelText =
                          buyerItem?.label || "Buyer Broker Compensation";
                        const buyerValue = parseFloat(buyerItem?.value?.toString().replace(/,/g, "") || 0) || 0;
                        const buyerRate = parseFloat(buyerItem?.rate?.toString().replace(/,/g, "") || 0) || 0;
                        const buyerRateVal =
                        buyerValue > 0 ? buyerValue : buyerRate ??
                          (getValues ? getValues("buyerAgentSplit") : "") ??
                          "";
                        return (
                          <>
                            <label className="heading-d">
                              {buyerLabelText}:
                            </label>
                            <div className={buyerValue > 0  ? "form-group sign-of-amount" : "form-group sign-of-percentage"}>
                              <FloatingNumber
                                type="text"
                                name="sellingAgent"
                                label=""
                                placeholder="0.00"
                                className="inpt-pla"
                                value={buyerRateVal}
                                onChange={(e) =>
                                  upsertCompensation(
                                    "buyer_broker_comp_pct",
                                    "buyerAgentSplit",
                                    buyerLabelText,
                                    e?.target?.value ?? ""
                                  )
                                }
                              />
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>

                <div className="property-question p-t-20 m-t-20 border-top-sec">
                  <div className="content-description">
                    <p className="heading-f txtclr">Closing date </p>
                  </div>
                </div>

                <div className="property-question m-t-20">
                  <div className="content-description">
                    <p className="heading-b txtclr">
                      What is the Estimated Closing Date:  
                    </p>
                  </div>
                  <div className="form-value">
                    <div className="form-group">
                      <FloatingInput
                        type="date"
                        name="loanInfoMeta.estimatedClosingDate"
                        label=""
                        placeholder="MM/DD/YYYY"
                        className="inpt-pla"
                        value={gv("loanInfoMeta.estimatedClosingDate", "")}
                        onChange={(e) =>
                          setValue &&
                          setValue(
                            "loanInfoMeta.estimatedClosingDate",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="property-question p-t-20 m-t-20 border-top-sec">
                  <div className="content-description">
                    <p className="heading-f txtclr">Warranty</p>
                  </div>
                </div>

                <div className="property-question m-t-20">
                  <div className="content-description">
                    <div className="d-flex-content">
                      <p className="heading-b txtclr">
                        Is the Seller paying for Home Warranty? &nbsp;&nbsp;
                      </p>
                      <div className="form-value">
                        <div className="frm-radio">
                          <label>
                            <input
                              type="radio"
                              name="homewarranty"
                              value="yes"
                              checked={useHomeWarranty === true}
                              onChange={() => setUseHomeWarranty(true)}
                            />{" "}
                            Yes
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="homewarranty"
                              value="no"
                              checked={useHomeWarranty === false}
                              onChange={() => setUseHomeWarranty(false)}
                            />{" "}
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-value">
                    <div className="form-group sign-of-amount">
                      <ControlledField
                        name="loanInfoMeta.homeWarrantyAmount"
                        control={control}
                        defaultValue={gv(
                          "loanInfoMeta.homeWarrantyAmount",
                          "0.00"
                        )}
                        InputComponent={FloatingNumber}
                        placeholder=""
                        type="text"
                        cleanNumber={cleanNumber}
                        handleCurrencyBlur={handleCurrencyBlur}
                        disabled={!useHomeWarranty}
                        style={{
                          backgroundColor: !useHomeWarranty
                            ? "#f3f4f6"
                            : "white",
                          cursor: !useHomeWarranty ? "not-allowed" : "text",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="middle-content-calc calculate-btn">
                  <button
                    className="submit-btn btn-bg inpt-btn"
                    onClick={handleCalculate}
                  >
                    Calculate
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
